import { _PdfMessageDigestAlgorithms } from './pdf-digest-algorithms';
import { _PdfSignerUtilities } from './signature-utilities';
var _PdfSignaturePrivateKey = /** @class */ (function () {
    function _PdfSignaturePrivateKey(hashAlgorithm, key) {
        this._key = key;
        var alg = new _PdfMessageDigestAlgorithms();
        var allowedDigest = alg._getAllowedDigests(hashAlgorithm);
        this._hashAlgorithm = alg._getDigest(allowedDigest);
        if (!key || this._isRonCipherKey(key)) {
            this._encryptionAlgorithm = 'RSA';
        }
        else {
            throw new Error('Invalid key type');
        }
    }
    _PdfSignaturePrivateKey.prototype._isRonCipherKey = function (key) {
        return 'modulus' in key && 'privateExponent' in key;
    };
    _PdfSignaturePrivateKey.prototype._sign = function (bytes) {
        try {
            var signMode = this._hashAlgorithm + "with" + this._encryptionAlgorithm;
            var util = new _PdfSignerUtilities();
            var signer = util._getSigner(signMode);
            signer._initialize(true, this._key);
            signer._blockUpdate(bytes, 0, bytes.length);
            return signer._generateSignature();
        }
        catch (error) {
            return null;
        }
    };
    _PdfSignaturePrivateKey.prototype._getHashAlgorithm = function () {
        return this._hashAlgorithm;
    };
    _PdfSignaturePrivateKey.prototype._getEncryptionAlgorithm = function () {
        return this._encryptionAlgorithm;
    };
    return _PdfSignaturePrivateKey;
}());
export { _PdfSignaturePrivateKey };
